import React from "react";
import { string, func } from "prop-types";
import { WithGoogleLogin } from "@quintype/components";

import Google from "../icons/social-share/google";

import { getSubscriptionInfo, getPushNotificationStatus } from "../../utils/utils";

const GoogleAuth = ({ googleClientId, setMember, setLoading, closePopup, text, setUpUserFlow, initiateCallback }) => {
  const socialLogin = (e, login) => {
    e.preventDefault();
    setLoading(true);
    initiateCallback && initiateCallback();

    window.dataLayer.push({
      event: "login_initiated",
      login_source: "Google login",
    });

    login()
      .then(({ member }) => {
        window.dataLayer.push({
          event: "login_completed",
        });
        setMember(member);

        getSubscriptionInfo({
          userid: `${member.id}`,
          login: `Yes - ${member["verification-status"]}`,
          connect_level: getPushNotificationStatus(),
        });
        setLoading(false);
        setUpUserFlow && setUpUserFlow();
        closePopup && closePopup();
      })
      .catch(() => {
        setLoading(false);
        window.dataLayer.push({
          event: "login_failed",
          login_failure_reason: "something went wrong!, please try again later",
        });
      });
  };

  return (
    <WithGoogleLogin clientId={googleClientId} scope="email" emailMandatory>
      {({ login, serverSideLoginPath }) => (
        <a href={serverSideLoginPath} onClick={(e) => socialLogin(e, login)}>
          <Google text={text} />
        </a>
      )}
    </WithGoogleLogin>
  );
};

GoogleAuth.propTypes = {
  googleClientId: string.isRequired,
  text: string.isRequired,
  setMember: func.isRequired,
  setLoading: func.isRequired,
  closePopup: func,
  setUpUserFlow: func,
  initiateCallback: func,
};

export default GoogleAuth;
